import { Injectable } from '@angular/core';
import { apiUrl } from '../constants/apiUrl';
import { HttpRequestService } from '../services/http-request.service';
import { getLocalStorage } from '../utils/storage';
import { keyStorage } from '../constants/storage';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    constructor(private httpRequestService: HttpRequestService) {}

    async getProfile() {
        try {
            // const result = await this.httpRequestService.axiosGetWithToken(
            //     apiUrl.profile
            // );
            const isAdmin = getLocalStorage(keyStorage.isAdmin) === '1';
            const result = await this.httpRequestService.axiosPostWithToken(apiUrl.profile, { isAdmin:  isAdmin});
            const response = {
                data: result.data as ProfileResponse | undefined,
                status: result.status,
                message: '',
            };
            return response;
        } catch (error) {
            return error;
        }
    }

    async updateProfile(param: any) {
        try {
            const result = await this.httpRequestService.axiosPutWithToken(
                apiUrl.profileUpdate,
                param
            );
            const response = {
                data: result.data,
                status: result.status,
                message: '',
            };
            return response;
        } catch (error) {
            return error;
        }
    }

    async deleteProfile() {
        try {
            const result = await this.httpRequestService.axiosDeleteWithToken(
                apiUrl.deleteUser
            );
            const response = {
                data: result.data,
                status: result.status,
                message: '',
            };
            return response;
        } catch (error) {
            return error;
        }
    }
}
